import { defineComponent as _defineComponent } from 'vue';
import ImageCard from '@blade-sxp/monitoring-center/pages/snap/components/imageCard.vue';
import { onMounted, onBeforeUnmount, ref } from 'vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'line-list',
    props: {
        imgList: null
    },
    emits: ['unfold', 'handleClick'],
    setup(__props, { emit }) {
        const props = __props;
        const currentOffset = ref(0);
        const maxOffset = ref(0);
        const itemWidth = ref(0);
        const containerWidth = ref(0);
        const sliderContainer = ref(null);
        const timer = ref(null);
        onMounted(() => {
            initialize();
            window.addEventListener('resize', initialize);
        });
        onBeforeUnmount(() => window.removeEventListener('resize', initialize));
        const initialize = () => {
            itemWidth.value = document.querySelector('.image-list img')?.offsetWidth;
            containerWidth.value = sliderContainer.value.offsetWidth;
            maxOffset.value = Math.floor(document.querySelector('.image-list')?.scrollWidth - containerWidth.value);
        };
        const handleClick = (portraitImage) => {
            emit('handleClick', portraitImage);
        };
        const prev = () => {
            if (currentOffset.value !== 0) {
                currentOffset.value += containerWidth.value;
                updateOffset();
            }
        };
        const next = () => {
            if (maxOffset.value < containerWidth.value || Math.abs(currentOffset.value) >= maxOffset.value) {
                return;
            }
            currentOffset.value -= containerWidth.value;
            updateOffset();
        };
        const updateOffset = () => {
            document.querySelector('.image-list').style.transform = `translateX(${currentOffset.value}px)`;
        };
        const hoverStart = () => {
            timer.value = setTimeout(() => {
                emit('unfold');
            }, 2000);
        };
        const hoverEnd = () => {
            clearTimeout(timer.value);
        };
        return { __sfc: true, props, emit, currentOffset, maxOffset, itemWidth, containerWidth, sliderContainer, timer, initialize, handleClick, prev, next, updateOffset, hoverStart, hoverEnd, ImageCard };
    }
});
